"use strict";
/*planCommandMonitorAddModule
策划中心 指挥监测中心  弹出框的样式设计
2017年 07-18  
 */
angular.module("planCommandMonitorEditSignedArticleModule", [])
    .controller('planCommandMonitorEditSignedArticleCtrl', ['$scope', '$modalInstance', 'item',
        function($scope, $modalInstance, item) {
            initStatus();
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.data = {
                    title: item.title || "更改标志文章",
                    content: item.content || "标志文章ID:",
                    confirmBtn: item.confirmBtn || "保存" ,
                    cancelBtn: item.cancelBtn || "取消",
                    guidValue: item.guidValue
                };
            }

            $scope.confirm = function() {
                $modalInstance.close($scope.data.guidValue);
            };

            /**
             * [cancel description] 取消
             * @return {[type]} [description]
             */
            $scope.cancel = function() {
                $modalInstance.close();
            };

            /**
             * [close description] 关闭
             * @return {[type]} [description]
             */
            $scope.close = function() {
                $modalInstance.dismiss();
            };
        }
    ]);